module.exports = __webpack_public_path__ + "static/media/3.149141d7.JPG";